export default {
  editEndpoint: '/company-path',
  updateEndpoint: '/user/change-path',
}
